const InviteEmailLogoPositionsEnum = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
};

export default Object.freeze(InviteEmailLogoPositionsEnum);
